
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/Public/_home",
      function () {
        return require("private-next-pages/apps/Public/_home/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/Public/_home"])
      });
    }
  